import { useMemo, useState, useEffect } from "react";
import {SetMetaData} from './../../helper/page-title';
import useInfiniteList from "../../hooks/infinite-list";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import { error_api_call, post_api_call, get_api_call} from "../../actions/action-creators/common";
import {filterTableData
} from "../../data/formData/glosco/resource";
import normalizeFilters from "../../helper/filter/normalize-filter";
import FilterFloatMaster from "../../components/form/filter/filter-float";
import {
  activeStatusOpp
} from "../../data/formData/option";
import ResListComp from "./resources-box";

function GloscoResourcesList(props) {
    SetMetaData("Manage GLOSCO Resources", "", "");
    const [filterData, setFilterData] = useState({});
    const [tmpFilterData, setTmpFilterData] = useState({});
    const [isProcess, setIsProcess] = useState({ filter: false});
    const [refreshKey, setRefreshKey] = useState(0);

    const [dropdownOpt, setDropdownOpt] = useState({
        active_status_id: activeStatusOpp,
        program_id: [],
        level_id: [],
        session_id: [],
        file_type: []
    });

    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            program_id      : "id",
            active_status_id: "id",
            session_id      : "id",
            level_id        : "id",
            file_type       : "id"
        }),
        [filterData]
    );

    const memoizedPayload = useMemo(() => ({
        fetch_type: "manage_resources",
        filter: normalizedFilter
    }), [normalizedFilter]); // Only changes when filters change

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["manage_resources", refreshKey],
        apiCall: payload => {
            return post_api_call("glosco-resources/list", payload)
        },
        limit: 100,
        // extraPayload: {
        //     fetch_type: "manage_resources",
        //     filter: normalizedFilter
        // }
        extraPayload: memoizedPayload, // Use the memoized version
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];

    //Get Data from APIs
    const fetchSelectList = async(type, url) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'manage_resources':
                    setDropdownOpt({...dropdownOpt,
                        program_id: data?.ifspd_programs,
                        level_id: data?.glosco_years,
                        session_id: data?.glosco_session
                    });
                    break;
                  default: 
              }
          }

          return {
              data
          };
      }catch(error){
        error_api_call({error: `admin|screens|glosco|resource-list|fetchSelectList|${error}`});
        return {data: []};
      }
    }

    useEffect(() => {
        fetchSelectList('manage_resources', `dropdown-options/ifspd_programs,glosco_session,glosco_years?fetch_type=resources`);
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const updateInput = (form_type, attrName, value, index=0) => {
        try {
            switch (form_type) {
                case 'filter':
                    let fieldsFilt = {...tmpFilterData};
                    fieldsFilt[attrName] = value;
                    setTmpFilterData({...fieldsFilt});
                    break;
                default: 
                    break;
            }
        } catch (error) {
            console.error(error);
            error_api_call({
                error: `admin|screens|glosco|resource-list|updateInput|${error}`
            });
        }
    };

    return (
        <>
        <div className="row">
            {/* Filter Res  */}
            <div className="col-lg-12">
                <div className="card p-2 mb-2">
                    {/* Filter by: */}
                    <FilterFloatMaster
                        title="Filter Resources"
                        formType="filter"
                        data={tmpFilterData}
                        _isProcess={{...isProcess}}
                        _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, field, value)}
                        _formData={[{label: "Filter Resources:", display_type: 'col', fields: [...filterTableData]}]}
                        _submitForm = {(e, form_type) => {e.preventDefault(); setFilterData({...tmpFilterData})}}
                        _is_download={false}
                        userRoleIds={props.userRoleIds}
                        selectOptions={{
                                    level_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.level_id]},
                                    program_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.program_id]},
                                    session_id:  {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.session_id]},
                                    file_type:  {value: 'id',
                                                label: 'file_type',
                                                data: [...props.fileTypeOpt]},
                                    active_status_id:{value: 'id',
                                                    label: 'status',
                                                    data: activeStatusOpp}
                                }}
                        _resetFilterForm = {(e) => {e.preventDefault(); setTmpFilterData({})}}
                    />
                </div>
            </div>
            {/* Listing Res */}
            <InfiniteListWrapper
                dataLength={masterTableData.length}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
                emptyMessage="No Record found!"
            >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card p-4 pb-0">

                        <div className="row">
                            {isLoading ? (
                                <div className="col-12 ps-2 pe-2">
                                        <img
                                            alt="Loader"
                                            src={require("../../assets/images/Image-Loader.gif")}
                                        />
                                </div>
                            ) : (
                                masterTableData.length > 0 
                                ? (
                                    <>
                                        {masterTableData.map((row, index) => {
                                            return (
                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 ps-2 pe-2 pb-4" key={index}>
                                                    <ResListComp
                                                        data={row}
                                                        // toggleModal={(e, mod_type, mod_state, data) => toggleModal(e, mod_type, mod_state, data)}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </>
                                )
                                : 
                                <div className="col-12 ps-2 pe-2">
                                    <div className="no-fellow text-center mt-4">
                                        {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                        <p className="pt-4 head">{"No Record Found!"}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </InfiniteListWrapper>
        </div>
        </>
    );
}

export default GloscoResourcesList;